export default class TextUtil {
  static isBatchimEnding(word: string) {
    const uni = word.charCodeAt(word.length - 1);
    if (uni < 44032 || uni > 55203) return null;
    return (uni - 44032) % 28 != 0;
  }

  static parseTextToArray = (text?: string) => {
    try {
      const parsedData = JSON.parse(text || '');
      if (Array.isArray(parsedData)) {
        return parsedData;
      } else {
        return [];
      }
    } catch (e) {
      return [];
    }
  };
}
